var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.167C7.67123 14.2611 10.0687 14.831 12.5 14.831C14.9313 14.831 17.3288 14.2611 19.5 13.167",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.0556C5.5 9.643 5.66389 9.24733 5.95561 8.95561C6.24733 8.66389 6.643 8.5 7.05556 8.5H17.9444C18.357 8.5 18.7527 8.66389 19.0444 8.95561C19.3361 9.24733 19.5 9.643 19.5 10.0556V17.0556C19.5 17.4681 19.3361 17.8638 19.0444 18.1555C18.7527 18.4472 18.357 18.6111 17.9444 18.6111H7.05556C6.643 18.6111 6.24733 18.4472 5.95561 18.1555C5.66389 17.8638 5.5 17.4681 5.5 17.0556V10.0556Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38867 8.50076V6.9452C9.38867 6.53264 9.55256 6.13698 9.84428 5.84526C10.136 5.55354 10.5317 5.38965 10.9442 5.38965H14.0553C14.4679 5.38965 14.8636 5.55354 15.1553 5.84526C15.447 6.13698 15.6109 6.53264 15.6109 6.9452V8.50076",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.3896V12.3984",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.de214610e820ee671c6ac0d8cef3bf5b.svg";
export { ForwardRef as ReactComponent };